import { IconUser as TablerIconUser } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconUser = /*#__PURE__*/ createOutlineIcon(TablerIconUser, 'IconUser');
